import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInactiveSendMessage = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			rx: 14,
			fill: "url(#paint0_linear_38212_703)"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_38212_703)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M22.1133 28.0717C22.145 28.1506 22.2 28.2179 22.271 28.2646C22.3421 28.3114 22.4257 28.3352 22.5107 28.3331C22.5957 28.3309 22.678 28.3028 22.7465 28.2525C22.815 28.2022 22.8666 28.1321 22.8941 28.0517L28.3108 12.2184C28.3375 12.1445 28.3426 12.0646 28.3255 11.988C28.3084 11.9114 28.2698 11.8412 28.2143 11.7857C28.1588 11.7302 28.0886 11.6916 28.012 11.6745C27.9354 11.6574 27.8555 11.6625 27.7816 11.6892L11.9483 17.1059C11.8679 17.1334 11.7978 17.185 11.7475 17.2535C11.6972 17.322 11.6691 17.4043 11.6669 17.4893C11.6648 17.5743 11.6886 17.6579 11.7354 17.729C11.7821 17.8 11.8494 17.855 11.9283 17.8867L18.5366 20.5367C18.7456 20.6203 18.9354 20.7454 19.0946 20.9044C19.2539 21.0634 19.3793 21.2529 19.4633 21.4617L22.1133 28.0717Z",
				stroke: "#A5A5A5",
				strokeWidth: 1.66667,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M28.2117 11.7891L19.095 20.905",
				stroke: "#A5A5A5",
				strokeWidth: 1.66667,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_38212_703",
			x1: 0,
			y1: 20,
			x2: 40,
			y2: 20,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#E6E9EC" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#CED2D9"
			})]
		}), /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_38212_703",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "white",
				transform: "translate(10.0001 10)"
			})
		})] })
	]
});
export default SvgInactiveSendMessage;
